$(".js-sign-up-modal").click(function clickOutSide(e) {
  if (
    !$(e.target).closest(".js-sign-up-form").length ||
    e.target.classList.contains("js-close-sign-up-modal")
  ) {
    hideSignUpModal();
  }
});

window.hideSignUpModal = function () {
  $("html").removeClass("no-scroll");
  $(".js-sign-up-modal").addClass("hide");
};

window.showSignUpModal = function () {
  $("html").addClass("no-scroll");
  $(".js-sign-up-modal").removeClass("hide");
};

if ($(".js-back-main").length) {
  //create new back element because original back element was anchor tag and we need to create button
  const newBackElement =
    "<button class='sign-up__header-btn js-close-sign-up-modal' title='بازگشت' >بازگشت <i class='icon-arrow-left'></i></button>";
  $(".js-back-main").after(newBackElement);
  $(".js-back-main").remove();
}
